import React from 'react';

import { GENDERS } from '../../Insurance.constants';

import { useGenderSelectorPresenter } from './GenderSelector.presenter';
import * as S from './GenderSelector.styles';

export const GenderSelector = ({ disabled, name, onChange, ...rest }) => {
  const presenter = useGenderSelectorPresenter({ name, onChange });

  return (
    <S.RadioGroup {...rest} name={name} onChange={presenter.onChange}>
      {GENDERS.map(({ id, value }) => {
        return <S.Radio disabled={disabled} key={id} label={value} value={id} />;
      })}
    </S.RadioGroup>
  );
};
